export const routes = {
  SCHEDULED_SERVICES: '/scheduled-services',
  LINK_EXPIRED: '/link-expired',
};
